import BnumElement from 'components/bnum-element';
import { Nullable } from '@rotomeca/utils';
import { Property, PropertyMode } from 'core/decorators/property';

export type CheckedChangeEventConstructorOption<
	TValue,
	TDetails,
	TCaller extends HTMLElement,
> = {
	value: TValue;
	checked: boolean;
	name: string;
	caller: TCaller;
	details?: Nullable<TDetails>;
};

export class CheckedChangeEvent<
	TValue,
	TDetails,
	TCaller extends BnumElement,
> extends CustomEvent<TDetails> {
	@Property({ mode: PropertyMode.init }) accessor value!: TValue;
	@Property({ mode: PropertyMode.init }) accessor name!: string;
	@Property({ mode: PropertyMode.init }) accessor checked!: boolean;
	@Property({ mode: PropertyMode.init }) accessor caller!: TCaller;

	constructor(
		options: CheckedChangeEventConstructorOption<TValue, TDetails, TCaller>,
	) {
		super(
			`${(options.caller.constructor as any).TAG}:change`,
			options.details ?? { bubbles: true, cancelable: true },
		);

		this.value = options.value;
		this.name = options.name;
		this.checked = options.checked;
		this.caller = options.caller;
	}
}
